// extracted by mini-css-extract-plugin
module.exports = {"container":"_25d45facb5--container--wGgfr","wrapper":"_25d45facb5--wrapper--yQcqV","static":"_25d45facb5--static--w1q82","inner":"_25d45facb5--inner--G55zI"};